import React from 'react';
import { Popup, Input, CustomButton, ToastNotification } from "components/shared";
import { TeamsService } from "services/http";
import utils from 'utils';

/**
 * team form component [CREATE, UPDATE]
 * @param {Object} props { teamName, description }
 * @returns React.Component
 */
export const TeamFormTemplate = (props) => {

    const { title, display, hideFnc, team } = props;
    const toastRef = React.useRef();
    const [teamObj, setTeamObj] = React.useState(team);

    /**
     * Init team payload for update action
     */
    React.useEffect(() => {
        setTeamObj(team);
    }, [team]);

    /**
     * Form submission action
     * @param {Event} e event listner
     */
    const onFormSubmission = (e) => {
        e.preventDefault();
        let Promise = !Object.keys(team).length ? TeamsService.addNewTeam(teamObj) : TeamsService.updateTeam(teamObj);
        Promise.then((response) => {
            props.hideFnc();
            props.successCallback(response.message);
        }, error => {
            props.errorCallback(error);
        });
    }

    return (
        <>
            <Popup
                header={title}
                visible={display}
                onHide={hideFnc}>
                <form onSubmit={onFormSubmission} style={{ width: "25vw" }}>
                    <Input
                        id="team-name"
                        placeholder="Team Name *"
                        required
                        value={teamObj.teamName}
                        parentClass="my-2"
                        onChange={(e) => { setTeamObj({ ...teamObj, teamName: e.target.value }) }}
                        icon="bi bi-people"
                    />

                    <Input
                        id="team-description"
                        placeholder="Team Description *"
                        required
                        value={teamObj.description}
                        parentClass="my-2"
                        onChange={(e) => { setTeamObj({ ...teamObj, description: e.target.value }) }}
                        icon="bi bi-card-text"
                    />

                    <hr />
                    <div className="my-2 w-100 d-flex">
                        <CustomButton
                            label={<><i className="bi bi-x-circle" />  CANCEL</>}
                            style={{ width: "50%" }}
                            className="p-button-warning"
                            onClick={(e) => { e.preventDefault(); props.hideFnc() }} />&nbsp;
                        <CustomButton
                            label={utils.labelTemplate(<><i className="bi bi-check-circle" /> SAVE</>, false, "Processing...")}
                            type="submit"
                            className={false && "not-allowed"}
                            style={{ width: "50%" }}
                        />
                    </div>
                </form>
            </Popup>
            <ToastNotification ref={toastRef} />
        </>
    );
}